<div [attr.id]="'section-' + props.id">
  <div
    *ngIf="props.label"
    class="panel-wrapper__header d-flex align-items-center px-3 py-1"
  >
    <div class="d-flex align-items-center flex-1">
      <div class="d-flex justify-content-between flex-1">
        <div class="d-flex align-items-start flex-1">
          <div class="d-flex align-items-center flex-1 me-2">
            <div
              *ngIf="props.icon"
              class="panel-wrapper__header-icon d-print-none me-2"
              [style.background-color]="props.iconBackgroundColor"
              [style.color]="props.iconColor"
            >
              <mat-icon class="w-100 h-100" [svgIcon]="props.icon"></mat-icon>
            </div>

            <h3 class="mat-h4"> {{ props.index }} {{ props.label }} </h3>

            <lui-avatar
              *ngIf="props.tooltip"
              color="primary"
              class="panel-wrapper__tooltip ms-1 d-print-none"
              [size]="20"
              [matTooltip]="props.tooltip.text"
              [useClickListener]="true"
            >
              <mat-icon svgIcon="i"></mat-icon>
            </lui-avatar>
          </div>

          <button
            *ngIf="props.notes && !props.readonly"
            luiCab
            size="md"
            class="ms-auto"
            (click)="toggleNotes(true)"
            type="button"
          >
            <mat-icon svgIcon="application_progress"></mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="props.permissions?.['readonly'] as readonlyPermission">
    <div class="p-2 bg-dangerLow" *ngIf="readonlyPermission?.status">
      <span class="fw-b colon pe-_5" i18n>Section disabled</span>

      <ng-container *ngIf="readonlyPermission.label">
        {{ readonlyPermission.label }}
      </ng-container>

      <lui-routed-label
        *ngIf="readonlyPermission.routedLabel"
        [routedLabel]="readonlyPermission.routedLabel"
      ></lui-routed-label>
    </div>
  </ng-container>

  <div #container>
    <div
      class="panel-wrapper__field-wrapper position-relative"
      [class.panel-wrapper__field-wrapper--readonly]="props.readonly"
    >
      <ng-container #fieldComponent></ng-container>
    </div>
  </div>
</div>

<div class="d-flex" [attr.id]="'section-' + props.id + '__notes'">
  <div class="panel-wrapper__notes mx-3 mb-3 p-4 pb-1 w-100" *ngIf="showNotes">
    <div class="d-flex justify-content-between mb-2">
      <div class="d-flex align-items-center">
        <lui-avatar [size]="48">
          <mat-icon svgIcon="application_progress"></mat-icon>
        </lui-avatar>
        <h4 class="ms-1">{{ props.label }} notes:</h4>
      </div>
      <button
        *ngIf="!addonsFields[0].defaultValue"
        luiCab
        iconPosition="end"
        size="md"
        class="panel-wrapper__notes-close-button align-self-start"
        (click)="toggleNotes(false)"
        type="button"
      >
        <ng-container i18n>Cancel</ng-container>
        <mat-icon svgIcon="delete"></mat-icon>
      </button>
    </div>

    <formly-form
      [fields]="addonsFields"
      (modelChange)="onModelChange($event)"
    ></formly-form>
  </div>
</div>
